<template>
    <div class="j-box">

        <div class="j-title" v-if="$slots.header">
            <slot name="header">This is the box header</slot>
        </div>

        <div class="j-content" v-if="$slots.default">
            <slot>This is the box content</slot>
        </div>

        <div class="j-footer" v-if="$slots.footer">
            <slot name="footer">This is the footer</slot>
        </div>

    </div>
</template>